import React from 'react';
import './Contact.css';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';

const ContactPage = () => {
  return (

    <>
      {/* Scrolling banner at the top */}
      <div className="scrolling-banner">
  <div className="scrolling-text">
     India–Singapore Collaboration   | India–Italy Collaboration   | 🌱 Empowering Sustainable Agriculture | 🌍 Global Green Partnerships.
  </div>
</div>

    <div className="unique-contact-wrapper">
      <div className="unique-contact-container">
        {/* Left Box */}
        <div className="unique-contact-left">
          <h2>Contact Us</h2>
          <p>
            We'd love to hear from you. Whether you have a question about services, pricing, or anything else,
            our team is ready to answer all your questions.
          </p>
          <div className="unique-contact-info">
            <div>
              <h4>📍 Address</h4>
              <p>Office no -7140, Floor no-07, Marvel Fuego, Opp. Seasons Mall, Magarpatta Road, Hadapsar, Pune, Maharashtra,-411028. 
              </p>
              <p>Singapore Address: Suntec Tower Three, Level 42, Suntec Tower Three8 Temasek Boulevard, Singapore 038988</p>
            </div>
            <div>
              <h4>📞 Phone</h4>
              <p>+91 7350552704</p>
            </div>
            <div>
              <h4>✉️ Email</h4>
              <p>hygenicagro123@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Right Box */}
        <div className="unique-contact-right">
          <h2>About Our Company</h2>
          <p>
         <h3>MISSION</h3>

Propose a wide range of ecological fertilizers ready to promote sustainable food system and satisfy any technical, economic and environmental need of the most advanced and environmentally friendly agriculture

Through careful selection of raw materials, both organic and mineral, and rigorous production processes, guarantee excellent standards of reliability, thereby enhancing the quality and amount of crops, preserving soil fertility and ensuring genuine and safe food for the consumer.

<h3>VISION</h3>

A sustainable agriculture capable of preserving our vital ecosystem, offering the farmer both safe and effective fertilizers to let agriculture grow in harmony with nature.

          </p>
          

          

          <h4>🏢 Headquarters</h4>
          <p>Suntec Tower Three, Level 42, Suntec Tower Three8 Temasek Boulevard, Singapore 038988</p>
        </div>
      </div>

      {/* Map directly below the containers */}
      <div className="unique-map-container">
       
        {/* <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.798766850179!2d103.85692447472447!3d1.2953147986923836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19aee7312125%3A0x97eca59f3a370668!2sServcorp%20-%20Suntec%20Tower%20Three!5e0!3m2!1sen!2sin!4v1748500176267!5m2!1sen!2sin" 
        allowfullscreen="" 
        loading="lazy" 
        ></iframe> */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.180687899362!2d73.93029587496297!3d18.52073518257283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1a06e2371e1%3A0x5e0899494cc931ec!2sHygenic%20Agro!5e0!3m2!1sen!2sin!4v1765455139443!5m2!1sen!2sin" 
        
        allowfullscreen="" 
        loading="lazy" 
        referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>

      {/* Social Icons */}
      <div className="unique-social-icons">
        <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebookF /></a>
        <a href="https://twitter.com" target="_blank" rel="noreferrer"><FaTwitter /></a>
        <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
        <a href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
      </div>
    </div>
    </>
  );
};

export default ContactPage;
